import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import HelpIcon from "../../../../../server/public/icons/Help.js";
import { createPortal } from "react-dom";
const element = document.querySelector("#window-container");
export default function LabelWithHelp(props) {
    var _a;
    const [open, setOpen] = useState(false);
    const ref = useRef();
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [from, setFrom] = useState("bottom");
    useEffect(() => {
        if (!ref.current || open === false)
            return;
        const boundingRect = ref.current.getBoundingClientRect();
        setY(innerHeight - boundingRect.bottom);
        setX(Math.min(boundingRect.left, innerWidth - 380));
    }, [open, ref]);
    return (React.createElement("div", { className: "label-with-help-container" },
        props.text,
        React.createElement("div", { className: "help-button-container", ref: ref, onMouseEnter: () => setOpen(true), onMouseLeave: () => setOpen(false) },
            props.iconOverride ?
                props.iconOverride
                : React.createElement(HelpIcon, { width: ((_a = props.small) !== null && _a !== void 0 ? _a : true) ? 18 : 25 }),
            open && x !== 0 ?
                createPortal(React.createElement("div", { className: "help-container", style: {
                        left: `${x}px`,
                        // top: from === 'top' ? `${y}px` : 'unset',
                        bottom: from === "bottom" ? `${y + 27}px` : undefined,
                    } }, props.help), element)
                : undefined)));
}
